import SectionHead from '../section/SectionHead.react'

import Config from '../../utils/Config';

class Team extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid()
        };

        this.toggleMask = this.toggleMask.bind(this);
    }

    toggleMask(visible, count) {
        $('#team-img'+this.state.uuid+count).css({ opacity : (visible ? 1 : 0) });
    }

    render() {
        var self    = this;
        var content = this.props.content;

        return (
            <section
                className='section team'
                id='team'>

                <SectionHead
                    className='white'
                    title={content.header.title}
                    subtitle={content.header.subtitle} />

                <div className='row row__100'>

                    { content.details.map(function(team, i) {
                        return (
                            <div
                                className='team__content'
                                key={'team_'+i}
                                onFocus={self.toggleMask}
                                onBlur={self.toggleMask}>

                                <div className='team__pic'>
                                    <img src={'/public/codi-studios/team/'+team.img+'.jpg'} alt='' />
                                    <div
                                        className='team__pic--mask'
                                        id={'team-img'+self.state.uuid+i} />
                                </div>

                                <h3>{team.name}</h3>
                                <span>{team.position}</span>
                                <p>{team.content}</p>
                            </div>
                        );
                    })}

                    <div style={{ 'clear' : 'both' }} />
                </div>
            </section>
        );
    }
}

export default Team;



// WEBPACK FOOTER //
// ./ui_src/app/components/team/Team.react.jsx